module.exports = __webpack_public_path__ + "assets/img/bg.6ed75cf3.png";